import { Paper, Title, Text, Stack, Group } from "@mantine/core";
import { browserName, browserVersion, fullBrowserVersion } from "react-device-detect";
import { IconWorld } from "@tabler/icons";
import IconBadge from "../../components/IconBadge";

const BROWSER_COLOR = "#1971c2";

export default function ModuleCurrentBrowser() {
  return (
    <Paper shadow="sm" radius="md" p="md" withBorder>
      <Group spacing="sm" noWrap align="flex-start">
        <IconBadge color={BROWSER_COLOR} icon={<IconWorld size={20} stroke={2.5} color={BROWSER_COLOR} />} />
        <Stack spacing={0} sx={{ minWidth: 0, flex: 1 }}>
          <Text size="xs" fw={700} tt="uppercase" color="dimmed" sx={{ letterSpacing: 0.4 }}>
            Current Browser
          </Text>
          {/* No line clamp - wraps onto a second line instead of being cut off. */}
          <Title order={2} weight={800}>
            {browserName}
          </Title>
          <Title order={5} weight={300} color="dimmed">
            Version: {fullBrowserVersion || browserVersion || "Unknown"}
          </Title>
        </Stack>
      </Group>
    </Paper>
  );
}
